"use client";
import { WHATSAPP_URL } from "@/app/lib/routes";
import { motion } from "motion/react";
import { useRef } from "react";
import { CommonTrackingEvents, rudderAnalytics } from "../lib/rudderstack";
import { Image } from "./Image";

interface WhatsAppButtonProps {
  bottomPosition?: string;
}

export function WhatsAppButton({ bottomPosition }: WhatsAppButtonProps) {
  const ref = useRef(window.document.body);

  return (
    <motion.a
      drag
      onClick={() =>
        rudderAnalytics.track(CommonTrackingEvents.USER_CONTACTED_SUPPORT)
      }
      href={WHATSAPP_URL}
      // https://mui.com/material-ui/customization/z-index/
      // The z-index is set to be below the MUI drawer which has a z-index of 1200
      className="fixed right-4 z-1100 rounded-full bg-surface-accent-stronger p-3 shadow shadow-black/40"
      dragMomentum={false}
      style={{
        bottom:
          bottomPosition ??
          "calc(var(--main-bottom-padding) + var(--footer-height, 0))",
      }}
      whileDrag={{ scale: 1.2 }}
      dragConstraints={ref}
    >
      <Image
        src="/whatsAppLogo.svg"
        className="pointer-events-none"
        width={24}
        height={24}
        alt="whatsapp-logo"
      />
    </motion.a>
  );
}
